document.addEventListener("DOMContentLoaded", () => {
  /* =====================================================
     ZANDRA STONE CUSTOM HEADER V12 JS
     Clean production version
  ===================================================== */

  /* -----------------------------
     Desktop Mega Menu
  ----------------------------- */

  const header = document.querySelector("[data-zs-header]");
  const mega = document.querySelector("[data-zs-mega]");
  const triggers = document.querySelectorAll("[data-zs-trigger]");
  const panels = document.querySelectorAll("[data-zs-panel]");
  let closeTimer;

  if (header && mega && triggers.length && panels.length) {
    const openPanel = (panelName) => {
      clearTimeout(closeTimer);

      mega.classList.add("is-active");

      panels.forEach((panel) => {
        panel.classList.toggle("is-active", panel.dataset.zsPanel === panelName);
      });

      triggers.forEach((trigger) => {
        trigger.classList.toggle("is-active", trigger.dataset.zsTrigger === panelName);
      });
    };

    const closeMega = () => {
      closeTimer = setTimeout(() => {
        mega.classList.remove("is-active");

        panels.forEach((panel) => {
          panel.classList.remove("is-active");
        });

        triggers.forEach((trigger) => {
          trigger.classList.remove("is-active");
        });
      }, 140);
    };

    triggers.forEach((trigger) => {
      trigger.addEventListener("mouseenter", () => {
        openPanel(trigger.dataset.zsTrigger);
      });

      trigger.addEventListener("focus", () => {
        openPanel(trigger.dataset.zsTrigger);
      });
    });

    header.addEventListener("mouseleave", closeMega);

    mega.addEventListener("mouseenter", () => {
      clearTimeout(closeTimer);
    });

    mega.addEventListener("mouseleave", closeMega);
  }

  /* -----------------------------
     Mobile Drawer
  ----------------------------- */

  const mobileOpen = document.querySelector("[data-zs-mobile-open]");
  const mobileDrawer = document.querySelector("[data-zs-mobile-drawer]");
  const mobileCloseButtons = document.querySelectorAll("[data-zs-mobile-close]");
  const mobileViews = document.querySelectorAll("[data-zs-mobile-view]");
  const mobileGoButtons = document.querySelectorAll("[data-zs-mobile-go]");
  const mobileBackButtons = document.querySelectorAll("[data-zs-mobile-back]");

  const setMobileView = (viewName) => {
    mobileViews.forEach((view) => {
      const viewId = view.dataset.zsMobileView;

      view.classList.toggle("is-active", viewId === viewName);
      view.classList.toggle("is-left", viewId === "main" && viewName !== "main");
    });
  };

  const closeMobileDrawer = () => {
    if (!mobileDrawer) return;

    mobileDrawer.classList.remove("is-active");
    document.documentElement.style.overflow = "";
    document.body.style.overflow = "";

    setTimeout(() => {
      setMobileView("main");
    }, 250);
  };

  if (mobileOpen && mobileDrawer) {
    mobileOpen.addEventListener("click", () => {
      mobileDrawer.classList.add("is-active");
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
      setMobileView("main");
    });

    mobileCloseButtons.forEach((button) => {
      button.addEventListener("click", closeMobileDrawer);
    });
  }

  mobileGoButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const targetView = button.dataset.zsMobileGo;

      if (targetView) {
        setMobileView(targetView);
      }
    });
  });

  mobileBackButtons.forEach((button) => {
    button.addEventListener("click", () => {
      setMobileView("main");
    });
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeMobileDrawer();
    }
  });

  /* -----------------------------
     Rotating Mega Menu Quotes
     Desktop + Mobile
  ----------------------------- */

  const quoteGroups = document.querySelectorAll(".zs-mega-links, .zs-mobile-submenu");

  quoteGroups.forEach((group) => {
    const quotes = group.querySelectorAll(".zs-mega-quote");

    if (!quotes.length) return;

    quotes.forEach((quote) => {
      quote.classList.remove("is-active");
    });

    let current = 0;
    quotes[current].classList.add("is-active");

    if (quotes.length <= 1) return;

    setInterval(() => {
      quotes[current].classList.remove("is-active");

      current = (current + 1) % quotes.length;

      quotes[current].classList.add("is-active");
    }, 6500);
  });

  /* -----------------------------
     Cart Drawer Fallback Trigger
     Keeps /cart as fallback if theme drawer is unavailable
  ----------------------------- */

  const cartLinks = document.querySelectorAll('[data-cart-toggle]');

  cartLinks.forEach((cartLink) => {
    cartLink.addEventListener("click", (event) => {
      const nativeCartTrigger =
        document.querySelector('[data-drawer-toggle="drawer-cart"]') ||
        document.querySelector('[data-drawer-toggle="cart"]') ||
        document.querySelector('[data-cart-drawer-toggle]') ||
        document.querySelector('[data-cart-drawer-open]') ||
        document.querySelector('[data-cart-toggle]:not(.zs-icon-link):not(.zs-mobile-icon-link)');

      if (!nativeCartTrigger || nativeCartTrigger === cartLink) return;

      event.preventDefault();
      nativeCartTrigger.click();
    });
  });
});
